import React from "react";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import UnauthMenu from "../User/UnauthMenu";
import AuthMenu from "../User/Auth/AuthMenu";

// component
const User = ({ isDisabled = false, onFocusScroll }) => {
    const { isLoggedIn, isLoading } = useSiteHeader();

    if (isLoading) return null;

    return isLoggedIn ? (
        <AuthMenu isDisabled={isDisabled} onFocusScroll={onFocusScroll} />
    ) : (
        <UnauthMenu isDisabled={isDisabled} onFocusScroll={onFocusScroll} />
    );
};

export default User;

import PropTypes from "prop-types";

// prop-types
User.propTypes = {
    isDisabled: PropTypes.bool,
    onFocusScroll: PropTypes.func
};
